import React, { useEffect } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icons in Leaflet with React
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

const LeafletMap = ({ markers, onMapClick, directions }) => {
  useEffect(() => {
    // Initialize map
    const map = L.map('map', {
      center: [-33.4489, -70.6693],
      zoom: 12,
      zoomControl: false, // We'll add it in a different position
      attributionControl: false // We'll add custom attribution
    });

    // Add zoom control in top right
    L.control.zoom({
      position: 'topright'
    }).addTo(map);

    // Add custom attribution
    L.control.attribution({
      position: 'bottomright',
      prefix: '&copy; <a href="https://www.maptiler.com/copyright/" target="_blank">MapTiler</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap contributors</a>'
    }).addTo(map);

    // Add MapTiler Streets style (Google-like)
    L.tileLayer('https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=vok5ZMIibwtSL3MmFAFU', {
      attribution: '&copy; <a href="https://www.maptiler.com/copyright/" target="_blank">MapTiler</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap contributors</a>',
      maxZoom: 20,
      minZoom: 3,
    }).addTo(map);

    // Add custom styles for the map (no color filters)
    const style = document.createElement('style');
    style.textContent = `
      .route-line {
        animation: dash 1s linear infinite;
        stroke: #4285F4 !important; /* Google blue */
      }
      @keyframes dash {
        to {
          stroke-dashoffset: -15;
        }
      }
    `;
    document.head.appendChild(style);

    // Add markers with custom style
    const mapMarkers = [];
    markers.forEach((marker, index) => {
      const customIcon = L.divIcon({
        className: 'custom-marker',
        html: `<div style="
          background-color: #8B0000;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 2px solid white;
          box-shadow: 0 2px 4px rgba(0,0,0,0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 12px;
          filter: none;
        ">${index + 1}</div>`,
        iconSize: [24, 24],
        iconAnchor: [12, 12]
      });

      const mapMarker = L.marker([marker.lat, marker.lng], { icon: customIcon }).addTo(map);
      mapMarkers.push(mapMarker);
      console.log(mapMarker);
      console.log("markadores",markers)
    });

    // Add route if directions exist
    let routeLine;
    if (directions && directions.paths && directions.paths[0]) {
      const path = directions.paths[0];
      if (path.points && path.points.coordinates) {
        const decodedPath = path.points.coordinates.map(coord => [coord[1], coord[0]]);
        routeLine = L.polyline(decodedPath, {
          color: '#4285F4', // Google blue
          weight: 6,
          opacity: 0.9,
          lineJoin: 'round',
          dashArray: '5, 10',
          className: 'route-line'
        }).addTo(map);
        
        // Add a white outline to make the route stand out
        L.polyline(decodedPath, {
          color: 'white',
          weight: 8,
          opacity: 0.5,
          lineJoin: 'round',
          className: 'route-line-outline'
        }).addTo(map);
        
        // Fit bounds to show the entire route and markers with padding
        if (decodedPath.length > 0) {
          const bounds = L.latLngBounds(decodedPath);
          map.fitBounds(bounds, {
            padding: [50, 50],
            maxZoom: 15
          });
        }
      }
    }

    // Handle map clicks
    map.on('click', (e) => {
      onMapClick({
        latLng: {
          lat: () => e.latlng.lat,
          lng: () => e.latlng.lng
        }
      });
    });

    // Cleanup
    return () => {
      mapMarkers.forEach(marker => marker.remove());
      if (routeLine) routeLine.remove();
      map.remove();
      document.head.removeChild(style);
    };
  }, [markers, directions, onMapClick]);

  return (
    <div id="map" style={{ 
      height: '500px', 
      width: '100%',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      overflow: 'hidden'
    }} />
  );
};

export default LeafletMap; 